'use client';

import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { SignInPasswordResetModal } from '@/app_components/SignIn/Components/SignInPasswordResetModal';
import type { ResetPasswordApiResponse } from '@/app_lib/types/accounts/signinApi';

interface SignInResetPasswordProps {
  email: string;
  onResetRequested: () => void;
}

export const SignInResetPassword = ({ email, onResetRequested }: SignInResetPasswordProps) => {
  const pathname = usePathname();

  const [resetModalOpen, setResetModalOpen] = useState(false);
  const [resetSuccess, setResetSuccess] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);

  const handleForgotPassword = async () => {
    onResetRequested();
    setResetSuccess(false);
    setResetLoading(true);
    setResetModalOpen(true);

    try {
      const origin = process.env.SITE_BASE_URL;
      const encodedResetUrl = encodeURI(`${origin}${pathname}`);
      const res = await fetch('/api/signin/reset-password', {
        body: JSON.stringify({ email, encodedResetUrl }),
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
      });
      const response: ResetPasswordApiResponse = await res.json();
      setResetSuccess(response.success === true);
    } catch {
      setResetSuccess(false);
    } finally {
      setResetLoading(false);
    }
  };

  return (
    <>
      <button
        className='typography-default font-medium cursor-pointer'
        onClick={handleForgotPassword}
        type='button'
      >
        Forgot password?
      </button>

      {resetModalOpen && (
        <SignInPasswordResetModal
          email={email}
          loading={resetLoading}
          resetSuccess={resetSuccess}
          setResetModalOpen={setResetModalOpen}
        />
      )}
    </>
  );
};
